export default [
    {
        path: '/',
        meta: {
        },
        component: () => import('@/views/1508/index')
    },
    {
        path: '/skillSwitch',
        meta: {
        },
        component: () => import('@/views/1508/skillSwitch')
    },
    {
        path: '/clerk/honor',
        meta: {
            menuName: '成就列表',
            menuPermission: 'gift_book'
        },
        component: () => import('@/views/1508/honor')
    },
    {
        path: '/clerk/gainHonor',
        meta: {
            menuName: '成就详情',
            menuPermission: 'gift_book'
        },
        component: () => import('@/views/1508/gainHonor')
    },
]